import { css } from '@emotion/react';

export const autocomplete_wrapper_styles = css`
  .MuiInputBase-input {
    flex: 1;
  }
`;
